import { AsyncAutocompleteFieldType, HookAutocompleteField } from 'components/shared/dropdowns'
import { useAccountsTypeaheadWithTypesQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

export const AccountTypesField: React.FC<AsyncAutocompleteFieldType> = props => {
  return (
    <HookAutocompleteField
      useQuery={useAccountsTypeaheadWithTypesQuery}
      transform={data =>
        data.accountsTypeahead.map(elem => {
          const label = elem.email ? `${elem.name} (${elem.email})` : `${elem.name}`
          return { label, value: elem }
        })
      }
      {...props}
    />
  )
}
